<span
  id="feedback-screend-reader"
  class="only-screen-reader"
  [ngClass]="{ hidden: hideStatusResult }"
  aria-live="assertive"
  aria-atomic="true"
>
  {{ statusResult }}
</span>
<ion-item
  class="line2"
  [ngClass]="{ 'line2-error': error, line2Borderless: labelInput }"
>
  <div class="input-text">
    <span *ngIf="error" class="error-text" aria-hidden="true">{{
      textError
    }}</span>
    <span
      *ngIf="!error && labelInputText && fieldValue.length > 0"
      class="place-text"
      aria-hidden="true"
      >{{ placeholder }}</span
    >
    <div class="box-search">
      <input
        #inputText
        id="{{ id }}"
        type="{{ type }}"
        [attr.aria-label]="error ? textError : label"
        [value]="fieldValue"
        [attr.placeholder]="fieldValue === '' ? placeholder : ''"
        (paste)="(isEnablePaste)"
        (drop)="(false)"
        (cut)="(false)"
        (drag)="(false)"
        (copy)="(false)"
        [attr.maxLength]="maxLength"
        [(ngModel)]="fieldValue"
        tabindex="0"
        (blur)="hideStatusResult = true"
        (keydown)="verifyMsgErrorAndroidInputText($event)"
        (keyup)="submitInput($event)"
        (input)="keyPressed($event); verifyMsgErrorIosInputText($event)"
        (change)="keyPressed($event)"
        autocomplete="off"
        enterkeyhint="go"
        charset="UTF-8"
        [disabled]="labelInput || disabled">
      </div>
  </div>
</ion-item>
